module.exports = __webpack_public_path__ + "img/H5.efdb8c71.png";